import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Card,
  Divider,
  Box,
  CardMedia,
  Button,
  styled,
  createTheme,
  ThemeProvider
} from '@mui/material';
import moment from 'moment';

const statistiquesFonctionPubliqueData = [
   {
    ministere: 'MINISTERE DE LA FONCTION PUBLIQUE, DU TRAVAIL ET DE L\'EMPLOI',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2023',
    description: 'Une analyse des données statistiques relatives à l’emploi, aux ressources humaines et aux politiques publiques mises en œuvre par le Ministère pour renforcer le secteur public.',
    date: "2024-12-31",
    link: "/documents/Sectorials/ANNUAIRESTATISTIQUEDEEDITION2023.pdf" 
  },
  {
    ministere: 'MINISTERE DE LA FONCTION PUBLIQUE, DU TRAVAIL ET DE L\'EMPLOI',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2022',
    description: 'Une analyse des données statistiques relatives à l’emploi, aux ressources humaines et aux politiques publiques mises en œuvre par le Ministère pour renforcer le secteur public.',
    date: "2022-12-31",
    link: "/documents/Sectorials/ANNUAIRE-STATISTIQUE-MFPTE-2022_VERSION-SIGNEE-07-05-2024-Noir-Blanc-1-1.pdf" 
  },
  {
    ministere: 'MINISTERE DE LA FONCTION PUBLIQUE, DU TRAVAIL ET DE L\'EMPLOI',
    annuaires: 'ANNUAIRE DES STATISTIQUES ÉDITION 2021',
    description: 'Des données statistiques sur le secteur de la fonction publique, fournissant un aperçu des ressources humaines et de l’exécution des politiques d’emploi pour améliorer les services publics.',
    date: "2021-12-31",
    link: "/documents/Sectorials/MFPTE_ANNUAIRE-STATISTIQUE_EDITION-2021_VERSION-FINALE.pdf" 
  },


];

function MinistereFonctionPublique() {
  const [visibleCount, setVisibleCount] = useState(4); 
  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C'
      },
      background: {
        default: '#f5f5f5'
      }
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C'
      },
      h4: {
        fontWeight: '600'
      }
    }
  });

  const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '20px'
  }));

  const handleShowMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 1, statistiquesFonctionPubliqueData.length));
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
            Ministère du Travail, de la Fonction Publique et de la Sécurité Sociale
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
            Cette page présente des statistiques relatives à l'emploi, aux ressources humaines et aux politiques publiques mises en œuvre par le Ministère.
          </Typography>
          
          {statistiquesFonctionPubliqueData.slice(0, visibleCount).map((statistique, index) => (
            <StyledCard key={index} elevation={3}>
              <Box sx={{ display: 'flex' }}>
                <a 
                  href={statistique.link} 
                  style={{ textDecoration: 'none', color: 'inherit' }} 
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <CardMedia
                    component="img"
                    sx={{ width: 71, height: 100, m: 2 }}
                    image={"assets/annuaires/minifonct.png"} 
                    alt={statistique.annuaires}
                  />
                </a>
                <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                  <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                    <a 
                      href={statistique.link} 
                     target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                     {<DownloadIcon />} {statistique.annuaires}
                    </a>
                  </Typography>
                  <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                    {statistique.description}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Publié en {moment(statistique.date).format('MMMM YYYY')}
                  </Typography>
                </Box>
              </Box>
            </StyledCard>
          ))}

          {/* Bouton pour afficher plus de rapports */}
          {visibleCount < statistiquesFonctionPubliqueData.length && (
            <Button 
              onClick={handleShowMore} 
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white'
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MinistereFonctionPublique;